// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___13U9Z","small":"style__small___1N2CJ","large":"style__large___2RvMf","inverted":"style__inverted___RwJMU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/loading/style.scss
// module id = 747
// module chunks = 51